import React from "react";

const CloseButton = ({ fill, svgIconSize }) => {
    return (
        <svg
            version="1.1"
            id="_x2014_ÎÓÈ_x5F_1"
            xmlns="http://www.w3.org/2000/svg"
            xmlnsXlink="http://www.w3.org/1999/xlink"
            viewBox="0 0 836.5 794"
            style={{
                enableBackground: "new 0 0 836.5 794",
                width: svgIconSize,
                pointerEvents: "none",
            }}
            xmlSpace="preserve"
        >
            <style type="text/css">
                {`.st0{display:none;fill:#FFFFFF;pointer-events:none;}
            .st1{display:none;fill:#3A8C35;pointer-events:none;}
            .st2{display:none;fill:#CB0600;pointer-events:none;}
            .st3{display:none;pointer-events:none;}
            .st4{display:inline;fill:#3A9930;pointer-events:none;}
            .st5{display:inline;pointer-events:none;}
            .st6{fill:#3A9930;pointer-events:none;}
            .st7{display:inline;fill:#DB0000;pointer-events:none;}
            .st8{display:none;fill:#DB0000;pointer-events:none;}
            .st9{display:none;fill:#3A9930;pointer-events:none;}
            .st10{fill:#FFFFFF;stroke:#000000;stroke-miterlimit:10;pointer-events:none;}`}
            </style>
            <rect
                x="-2088"
                y="-88"
                className="st0"
                width="8000"
                height="2000"
            />
            <g>
                <path
                    className="st1"
                    d="M-583.3,1031.4c-209.6,0-379.5,169.9-379.5,379.5s169.9,379.5,379.5,379.5s379.5-169.9,379.5-379.5
                S-373.7,1031.4-583.3,1031.4z M-628.7,1548.4L-628.7,1548.4L-628.7,1548.4L-770,1407.1l42.9-42.9l98.4,98.2l189.2-189.4
                c0,0,0,0,0,0l42.9,43.1L-628.7,1548.4z"
                />
                <path
                    className="st2"
                    d="M1418.2,1031.4c-209.6,0-379.5,169.9-379.5,379.5s169.9,379.5,379.5,379.5s379.5-169.9,379.5-379.5
                S1627.8,1031.4,1418.2,1031.4z M1568.4,1517l-44.2,44.2l-106-106.1l-106.1,106l-44.2-44.2l106.1-106l-106-106.1l44.2-44.2
                l106,106.1l106.1-106l44.2,44.2l-106.1,106L1568.4,1517z"
                />
                <path
                    className="st2"
                    d="M5409.7,1031.6c-209.6,0-379.5,169.9-379.5,379.5s169.9,379.5,379.5,379.5c209.6,0,379.5-169.9,379.5-379.5
                S5619.3,1031.6,5409.7,1031.6z M5591,1442.5l-361-0.2v-62.5l361,0.2V1442.5z"
                />
                <path
                    className="st1"
                    d="M3412.8,1031.4c-209.6,0-379.5,169.9-379.5,379.5s169.9,379.5,379.5,379.5c209.6,0,379.5-169.9,379.5-379.5
                S3622.4,1031.4,3412.8,1031.4z M3582,1440.9l-139.2,0l-0.2,139.1h-59.8l-0.4-139.1l-140.4-0.1v-59.8l140.4-0.5l0.6-140.4h59.8
                l0,140.5l139.2,0.6V1440.9z"
                />
                <g className="st3">
                    <path
                        className="st4"
                        d="M-1583.8,1792.4c-51.5,0-101.4-10.1-148.5-30c-45.4-19.2-86.2-46.7-121.2-81.7c-35-35-62.5-75.8-81.7-121.2
                    c-19.9-47-30-97-30-148.5c0-51.5,10.1-101.4,30-148.5c19.2-45.4,46.7-86.2,81.7-121.2c35-35,75.8-62.5,121.2-81.7
                    c47-19.9,97-30,148.5-30s101.4,10.1,148.5,30c45.4,19.2,86.2,46.7,121.2,81.7c35,35,62.5,75.8,81.7,121.2c19.9,47,30,97,30,148.5
                    c0,51.5-10.1,101.4-30,148.5c-19.2,45.4-46.7,86.2-81.7,121.2c-35,35-75.8,62.5-121.2,81.7
                    C-1482.4,1782.3-1532.3,1792.4-1583.8,1792.4z M-1583.8,1084c-180.3,0-326.9,146.6-326.9,326.9s146.6,326.9,326.9,326.9
                    s326.9-146.6,326.9-326.9S-1403.5,1084-1583.8,1084z"
                    />
                </g>
                <g className="st3">
                    <g className="st5">
                        <g>
                            <polygon
                                className="st6"
                                points="-1397.1,1316.4 -1440,1273.5 -1440,1273.5 -1629.2,1462.7 -1727.6,1364.3 -1770.4,1407.1
                            -1629.2,1548.4 -1629.2,1548.3 -1629.1,1548.4 				"
                            />
                        </g>
                    </g>
                </g>
                <g className="st3">
                    <path
                        className="st7"
                        d="M418,1792.2c-51.5,0-101.4-10.1-148.4-30c-45.4-19.2-86.2-46.7-121.2-81.7c-35-35-62.5-75.8-81.7-121.2
                    c-19.9-47-30-96.9-30-148.4s10.1-101.4,30-148.4c19.2-45.4,46.7-86.2,81.7-121.2c35-35,75.8-62.5,121.2-81.7
                    c47-19.9,96.9-30,148.4-30s101.4,10.1,148.4,30c45.4,19.2,86.2,46.7,121.2,81.7c35,35,62.5,75.8,81.7,121.2
                    c19.9,47,30,96.9,30,148.4s-10.1,101.4-30,148.4c-19.2,45.4-46.7,86.2-81.7,121.2c-35,35-75.8,62.5-121.2,81.7
                    C519.4,1782.1,469.5,1792.2,418,1792.2z M418,1084.2c-180.2,0-326.7,146.6-326.7,326.7s146.6,326.7,326.7,326.7
                    c180.2,0,326.7-146.6,326.7-326.7S598.2,1084.2,418,1084.2z"
                    />
                </g>
                <g className="st3">
                    <path
                        className="st4"
                        d="M2415.6,1789.3c-51.1,0-100.6-10-147.3-29.7c-45.1-19.1-85.5-46.3-120.2-81.1c-34.7-34.7-62-75.2-81.1-120.2
                    c-19.7-46.7-29.7-96.2-29.7-147.3s10-100.6,29.7-147.3c19.1-45.1,46.3-85.5,81.1-120.2c34.7-34.7,75.2-62,120.2-81.1
                    c46.7-19.7,96.2-29.7,147.3-29.7s100.6,10,147.3,29.7c45.1,19.1,85.5,46.3,120.2,81.1c34.7,34.7,62,75.2,81.1,120.2
                    c19.7,46.7,29.7,96.2,29.7,147.3s-10,100.6-29.7,147.3c-19.1,45.1-46.3,85.5-81.1,120.2c-34.7,34.7-75.2,62-120.2,81.1
                    C2516.2,1779.3,2466.7,1789.3,2415.6,1789.3z M2415.6,1086.7c-178.8,0-324.2,145.5-324.2,324.2s145.5,324.2,324.2,324.2
                    s324.2-145.5,324.2-324.2S2594.4,1086.7,2415.6,1086.7z"
                    />
                </g>
                <g className="st3">
                    <path
                        className="st7"
                        d="M4411.2,1790.3c-51.2,0-100.9-10-147.7-29.8c-45.2-19.1-85.7-46.5-120.6-81.3s-62.2-75.4-81.3-120.6
                    c-19.8-46.8-29.8-96.5-29.8-147.7s10-100.9,29.8-147.7c19.1-45.2,46.5-85.7,81.3-120.6c34.8-34.8,75.4-62.2,120.6-81.3
                    c46.8-19.8,96.5-29.8,147.7-29.8s100.9,10,147.7,29.8c45.2,19.1,85.7,46.5,120.6,81.3c34.8,34.8,62.2,75.4,81.3,120.6
                    c19.8,46.8,29.8,96.5,29.8,147.7s-10,100.9-29.8,147.7c-19.1,45.2-46.5,85.7-81.3,120.6c-34.8,34.8-75.4,62.2-120.6,81.3
                    C4512.1,1780.2,4462.4,1790.3,4411.2,1790.3z M4411.2,1085.8c-179.3,0-325.1,145.8-325.1,325.1s145.8,325.1,325.1,325.1
                    s325.1-145.8,325.1-325.1S4590.5,1085.8,4411.2,1085.8z"
                    />
                </g>
                <polygon
                    className="st8"
                    points="556.9,1313 516,1272.2 418,1370.1 320.1,1272.1 279.3,1312.9 377.2,1410.9 279.1,1508.8 320,1549.7
                418,1451.8 515.9,1549.8 556.8,1509 458.9,1411 	"
                />
                <rect
                    x="4230"
                    y="1379.7"
                    className="st8"
                    width="363"
                    height="62.5"
                />
                <polygon
                    className="st9"
                    points="2585,1381.1 2445.5,1380.3 2445.6,1240 2385.8,1240 2385.7,1380.3 2246,1380.9 2246,1440.8
                2385.6,1440.6 2385.6,1580 2445.5,1580 2445.5,1440.6 2585,1440.9 	"
                />
                <path
                    className="st3"
                    d="M-583.3,33.6c-209.6,0-379.5,169.9-379.5,379.5s169.9,379.5,379.5,379.5s379.5-169.9,379.5-379.5
                S-373.7,33.6-583.3,33.6z M-628.7,550.5L-628.7,550.5L-628.7,550.5L-770,409.3l42.9-42.9l98.4,98.1L-439.6,275c0,0,0,0,0,0
                l42.9,43.2L-628.7,550.5z"
                />
                <path
                    className="st3"
                    d="M1418.2,33.6c-209.6,0-379.5,169.9-379.5,379.5s169.9,379.5,379.5,379.5s379.5-169.9,379.5-379.5
                S1627.8,33.6,1418.2,33.6z M1568.4,519.2l-44.2,44.2l-106-106.1l-106.1,106l-44.2-44.2L1374,413l-106-106.1l44.2-44.2l106,106.1
                l106.1-106l44.2,44.2l-106.1,106L1568.4,519.2z"
                />
                <path
                    className="st3"
                    d="M5409.7,33.7c-209.6,0-379.5,169.9-379.5,379.5s169.9,379.5,379.5,379.5c209.6,0,379.5-169.9,379.5-379.5
                S5619.3,33.7,5409.7,33.7z M5591,444.6l-361-0.2v-62.5l361,0.2V444.6z"
                />
                <path
                    className="st3"
                    d="M3412.8,33.6c-209.6,0-379.5,169.9-379.5,379.5s169.9,379.5,379.5,379.5c209.6,0,379.5-169.9,379.5-379.5
                S3622.4,33.6,3412.8,33.6z M3582,443.1l-139.2-0.1l-0.2,139h-59.8l-0.4-139.1l-140.4,0v-59.8l140.4-0.5L3383,242h59.8l0,140.5
                l139.2,0.7V443.1z"
                />
                <ellipse
                    className="st10"
                    cx="416"
                    cy="405"
                    rx="353.5"
                    ry="362.5"
                />
                <path
                    d="M414,777.3c-51.5,0-101.4-10.1-148.4-30c-45.4-19.2-86.2-46.7-121.2-81.7c-35-35-62.5-75.8-81.7-121.2
                c-19.9-47-30-96.9-30-148.4s10.1-101.4,30-148.4c19.2-45.4,46.7-86.2,81.7-121.2c35-35,75.8-62.5,121.2-81.7
                c47-19.9,96.9-30,148.4-30s101.4,10.1,148.4,30c45.4,19.2,86.2,46.7,121.2,81.7c35,35,62.5,75.8,81.7,121.2
                c19.9,47,30,96.9,30,148.4s-10.1,101.4-30,148.4c-19.2,45.4-46.7,86.2-81.7,121.2c-35,35-75.8,62.5-121.2,81.7
                C515.4,767.2,465.5,777.3,414,777.3z M414,69.3c-180.2,0-326.7,146.6-326.7,326.7S233.9,722.8,414,722.8
                c180.2,0,326.7-146.6,326.7-326.7S594.2,69.3,414,69.3z"
                />
                <g className="st3">
                    <path
                        className="st5"
                        d="M-1583.8,794.5c-51.5,0-101.4-10.1-148.5-30c-45.4-19.2-86.2-46.7-121.2-81.7c-35-35-62.5-75.8-81.7-121.2
                    c-19.9-47-30-97-30-148.5s10.1-101.4,30-148.5c19.2-45.4,46.7-86.2,81.7-121.2c35-35,75.8-62.5,121.2-81.7c47-19.9,97-30,148.5-30
                    s101.4,10.1,148.5,30c45.4,19.2,86.2,46.7,121.2,81.7c35,35,62.5,75.8,81.7,121.2c19.9,47,30,97,30,148.5s-10.1,101.4-30,148.5
                    c-19.2,45.4-46.7,86.2-81.7,121.2c-35,35-75.8,62.5-121.2,81.7C-1482.4,784.4-1532.3,794.5-1583.8,794.5z M-1583.8,86.2
                    c-180.3,0-326.9,146.6-326.9,326.9S-1764,740-1583.8,740s326.9-146.6,326.9-326.9S-1403.5,86.2-1583.8,86.2z"
                    />
                </g>
                <g className="st3">
                    <g className="st5">
                        <g>
                            <polygon
                                points="-1397.1,318.5 -1440,275.6 -1440,275.6 -1629.2,464.8 -1727.6,366.4 -1770.4,409.3 -1629.2,550.5
                            -1629.2,550.4 -1629.1,550.5 				"
                            />
                        </g>
                    </g>
                </g>
                <g className="st3">
                    <path
                        className="st5"
                        d="M2415.6,791.4c-51.1,0-100.6-10-147.3-29.7c-45.1-19.1-85.5-46.3-120.2-81.1c-34.7-34.7-62-75.2-81.1-120.2
                    c-19.7-46.7-29.7-96.2-29.7-147.3c0-51.1,10-100.6,29.7-147.3c19.1-45.1,46.3-85.5,81.1-120.2c34.7-34.7,75.2-62,120.2-81.1
                    c46.7-19.7,96.2-29.7,147.3-29.7s100.6,10,147.3,29.7c45.1,19.1,85.5,46.3,120.2,81.1c34.7,34.7,62,75.2,81.1,120.2
                    c19.7,46.7,29.7,96.2,29.7,147.3c0,51.1-10,100.6-29.7,147.3c-19.1,45.1-46.3,85.5-81.1,120.2c-34.7,34.7-75.2,62-120.2,81.1
                    C2516.2,781.4,2466.7,791.4,2415.6,791.4z M2415.6,88.8c-178.8,0-324.2,145.5-324.2,324.2s145.5,324.2,324.2,324.2
                    s324.2-145.5,324.2-324.2S2594.4,88.8,2415.6,88.8z"
                    />
                </g>
                <g className="st3">
                    <path
                        className="st5"
                        d="M4411.2,792.4c-51.2,0-100.9-10-147.7-29.8c-45.2-19.1-85.7-46.5-120.6-81.3c-34.8-34.8-62.2-75.4-81.3-120.6
                    c-19.8-46.8-29.8-96.5-29.8-147.7s10-100.9,29.8-147.7c19.1-45.2,46.5-85.7,81.3-120.6c34.8-34.8,75.4-62.2,120.6-81.3
                    c46.8-19.8,96.5-29.8,147.7-29.8s100.9,10,147.7,29.8c45.2,19.1,85.7,46.5,120.6,81.3c34.8,34.8,62.2,75.4,81.3,120.6
                    c19.8,46.8,29.8,96.5,29.8,147.7s-10,100.9-29.8,147.7c-19.1,45.2-46.5,85.7-81.3,120.6c-34.8,34.8-75.4,62.2-120.6,81.3
                    C4512.1,782.4,4462.4,792.4,4411.2,792.4z M4411.2,88c-179.3,0-325.1,145.8-325.1,325.1s145.8,325.1,325.1,325.1
                    s325.1-145.8,325.1-325.1S4590.5,88,4411.2,88z"
                    />
                </g>
                <polygon
                    points="552.9,298.2 512,257.3 414,355.2 316.1,257.2 275.3,298 373.2,396 275.1,494 316,534.8 414,436.9 511.9,534.9
                552.8,494.1 454.9,396.1 	"
                />
                <rect
                    x="4230"
                    y="381.8"
                    className="st3"
                    width="363"
                    height="62.5"
                />
                <polygon
                    className="st3"
                    points="2585,383.2 2445.5,382.4 2445.6,242 2385.8,242 2385.7,382.4 2246,383.1 2246,442.9 2385.6,442.7
                2385.6,582 2445.5,582 2445.5,442.7 2585,443.1 	"
                />
            </g>
        </svg>
    );
};

export default CloseButton;
